export function argsToString(args){
    return JSON.stringify(args);
}